export default __webpack_public_path__ + "static/media/bt.78c30351.svg";